module.exports = __webpack_public_path__ + "img/programme8.ec366326.png";